import React, { useContext, useMemo } from "react";
import authContext from "../../context/authentication/authContex";

const DictionaryText = ({text}) => {
    const {globalSettings} = useContext(authContext);
    
    const valueToDisplay = useMemo(()=>{
        return Object.values(globalSettings?.dictionary ?? {}).flat().find(w => w.original == text);
    },[globalSettings,text])
    
    return valueToDisplay?.actual ?? text;
}

export default React.memo(DictionaryText);